<div class="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/50 px-4 py-6" role="dialog" aria-modal="true" aria-labelledby="favorite-alert-consent-title">
  <div class="w-full max-w-lg rounded-2xl border border-gray-200 bg-white p-6 shadow-2xl md:p-8">
    <div class="space-y-4">
      <h2 id="favorite-alert-consent-title" class="text-gray-900 text-2xl font-extrabold font-['Inter'] leading-8">
        Quer receber notificações por e-mail sobre este imóvel?
      </h2>

      <div class="space-y-3 text-gray-500 text-base font-normal font-['Inter'] leading-relaxed">
        <p>
          Ao adicionar este imóvel aos favoritos, podemos te enviar avisos por e-mail sobre atualizações e mudanças relevantes relacionadas a ele.
        </p>
        <p>
          Você pode alterar essa preferência a qualquer momento em Minha conta.
        </p>
      </div>

      <p class="rounded-md bg-blue-50 px-4 py-3 text-blue-900 text-sm font-normal font-['Inter'] leading-relaxed">
        Ao aceitar, você autoriza a Casato Brasil a enviar alertas sobre seus imóveis salvos, conforme nossa Política de Privacidade.
      </p>

      @if (errorMessage) {
        <p class="rounded-md bg-red-50 px-4 py-3 text-red-700 text-sm font-normal font-['Inter'] leading-relaxed">
          {{ errorMessage }}
        </p>
      }
    </div>

    <div class="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
      <button
        type="button"
        class="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-5 py-3 text-center text-sm font-medium text-gray-900 hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-gray-100 disabled:opacity-50"
        [disabled]="isSaving"
        (click)="declined.emit()">
        Não quero receber
      </button>

      <button
        type="button"
        class="inline-flex w-full justify-center rounded-md bg-blue-700 px-5 py-3 text-center text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-200 disabled:opacity-50"
        [disabled]="isSaving"
        (click)="accepted.emit()">
        Sim, quero receber
      </button>
    </div>
  </div>
</div>
